import { render, staticRenderFns } from "./Peru.vue?vue&type=template&id=6b6a2dd9&scoped=true&"
import script from "./Peru.vue?vue&type=script&lang=js&"
export * from "./Peru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a2dd9",
  null
  
)

export default component.exports